var React = require('react');

function Envelope (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8 7.70362L0 2.78631V1.62818C0 1.28643 0.0989583 0.998481 0.296875 0.764323C0.494792 0.530165 0.729167 0.413086 1 0.413086H15C15.2708 0.413086 15.5052 0.530165 15.7031 0.764323C15.901 0.998481 16 1.28643 16 1.62818V2.78631L8 7.70362ZM7.5 8.91871H8.5L16 4.19126V13.7791C16 14.1082 15.901 14.3929 15.7031 14.6334C15.5052 14.8739 15.2708 14.9942 15 14.9942H1C0.729167 14.9942 0.494792 14.8739 0.296875 14.6334C0.0989583 14.3929 0 14.1082 0 13.7791V4.19126L7.5 8.91871Z","fill":"#3C4652"}));
}

Envelope.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = Envelope;

Envelope.default = Envelope;
